import { render, staticRenderFns } from "./ConfirmationTypeModal.vue?vue&type=template&id=84785348&"
import script from "./ConfirmationTypeModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmationTypeModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConfirmationTypeModal.vue?vue&type=style&index=0&id=84785348&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports